import React from 'react';
import { styled } from '@mui/material/styles';

// Define the variants and sizes as constants
const VARIANTS = [
  { variant: '1x1', ratio: 1 },
  { variant: '4x3', ratio: 1.3333 },
];

const SIZES = [
  { size: 'small', height: 16 },
  { size: 'medium', height: 32 },
  { size: 'large', height: 48 },
  { size: 'x-large', height: 64 }
];

// Create a basic wrapper styled component
const FlagWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'ratio' && prop !== 'size' && prop !== 'rounded'
})(({ ratio, size, rounded }) => {
  // Find the variant and size objects
  const variantObj = VARIANTS.find(v => v.variant === ratio);
  const sizeObj = SIZES.find(s => s.size === size);
  
  if (!variantObj || !sizeObj) {
    return { };
  }
  
  return {
    position: 'relative',
    width: `${sizeObj.height * variantObj.ratio}px`,
    height: `${sizeObj.height}px`,
    overflow: rounded ? 'hidden' : 'visible'
  };
});

// Create a styled component for the flag image
const FlagImage = styled('img', {
  shouldForwardProp: (prop) => (
    prop !== 'ratio' && prop !== 'size' && prop !== 'disabled' && prop !== 'rounded'
  )
})(({ ratio, size, disabled, rounded }) => {
  // Find the variant and size objects
  const variantObj = VARIANTS.find(v => v.variant === ratio);
  const sizeObj = SIZES.find(s => s.size === size);
  
  if (!variantObj || !sizeObj) {
    return { };
  }
  
  return {
    width: `${sizeObj.height * variantObj.ratio}px`,
    height: `${sizeObj.height}px`,
    border: '1px solid #cacaca',
    filter: disabled ? 'grayscale(100%)' : 'none',
    borderRadius: rounded ? '50%' : '0'
  };
});

const Flag = React.forwardRef((props, ref) => {
  const { 
    code, 
    ratio = '4x3', 
    size = 'medium', 
    disabled = false, 
    rounded = false,
    ...otherProps 
  } = props;
  
  return (
    <FlagWrapper 
      ref={ref} 
      ratio={ratio} 
      size={size} 
      rounded={rounded}
      {...otherProps}
    >
      <FlagImage 
        alt={code} 
        ratio={ratio} 
        size={size} 
        disabled={disabled} 
        rounded={rounded}
        src={`${process.env.PUBLIC_URL}/imgs/flags/${ratio}/${code}.svg`}
      />
    </FlagWrapper>
  );
});

export default Flag;